class HommegirlsProductGrid extends HTMLElement {
  constructor() {
    super();
    this.loading = false;
    /** @type {HTMLAnchorElement | null} */
    this.loadMoreBtn = null;
    /** @type {IntersectionObserver | null} */
    this.observer = null;
  }

  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  init() {
    this.loadMoreBtn = this.parentElement?.querySelector('.collection__load-more') ?? null;
    if (!this.loadMoreBtn) return;
    this.observer = new IntersectionObserver(this.onIntersect.bind(this), { rootMargin: '200px' });
    this.observer.observe(this.loadMoreBtn);
  }

  /** @param {IntersectionObserverEntry[]} entries */
  async onIntersect(entries) {
    if (!entries[0]?.isIntersecting || this.loading) return;
    await this.loadMore();
  }

  async loadMore() {
    const loadMoreBtn = this.loadMoreBtn;
    if (!loadMoreBtn) return;
    const url = loadMoreBtn.href;
    this.loading = true;
    loadMoreBtn.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url);
      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');

      const newGrid = doc.querySelector('hommegirls-product-grid');
      if (newGrid) {
        [...newGrid.children].forEach(el => this.appendChild(el));
      }

      const nextBtn = doc.querySelector('.collection__load-more');
      if (nextBtn instanceof HTMLAnchorElement) {
        loadMoreBtn.href = nextBtn.href;
      } else {
        this.observer?.disconnect();
        loadMoreBtn.remove();
        this.loadMoreBtn = null;
      }
    } catch (e) {
      console.error('Failed to load more products', e);
    } finally {
      this.loading = false;
      loadMoreBtn.removeAttribute('aria-busy');
    }
  }
}

customElements.define('hommegirls-product-grid', HommegirlsProductGrid);
